import { render, staticRenderFns } from "./CountryDetail.vue?vue&type=template&id=35dcaf94&scoped=true"
import script from "./CountryDetail.vue?vue&type=script&lang=ts"
export * from "./CountryDetail.vue?vue&type=script&lang=ts"
import style0 from "./CountryDetail.vue?vue&type=style&index=0&id=35dcaf94&lang=scss"
import style1 from "./CountryDetail.vue?vue&type=style&index=1&id=35dcaf94&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dcaf94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35dcaf94')) {
      api.createRecord('35dcaf94', component.options)
    } else {
      api.reload('35dcaf94', component.options)
    }
    module.hot.accept("./CountryDetail.vue?vue&type=template&id=35dcaf94&scoped=true", function () {
      api.rerender('35dcaf94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/locations/countries/components/CountryDetail.vue"
export default component.exports